import { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Menu,
  MenuItem,
  FormControl,
  Select,
  SelectChangeEvent,
  InputLabel,
  Divider,
  IconButton,
  Chip,
  TextField,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import "./users.css";
import { useNavigate } from "react-router-dom";
import { addUserRole } from "../../../utils/Constant";
import { useDispatch, useSelector } from "react-redux";
import {
  GridColDef,
  GridRenderCellParams,
  GridRowSelectionModel,
} from "@mui/x-data-grid";
import Table from "../../../components/table/table";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import CreateClientUser from "./create-client-user/create-client-user";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltOffOutlinedIcon from "@mui/icons-material/FilterAltOffOutlined";
import { ClearAllOutlined } from "@mui/icons-material";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import CreateInternalUser from "./create-internal-user/create-internal-user";
import { getAllUserRequest } from "../../../redux/users/slice";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import ArrowUpwardOutlinedIcon from "@mui/icons-material/ArrowUpwardOutlined";
import ArrowDownwardOutlinedIcon from "@mui/icons-material/ArrowDownwardOutlined";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import Notification from "../../../components/notification/notification";
import { userType as currentUserType } from "../../../utils/Constant";
import CreateInspectorUser from "./create-inspector-user/create-inspector-user";
import DeactivateUserDialog from "./user-details/user-details-tab/deactivate-user/deactivate-user";
import ReActivateUserDialog from "./user-details/user-details-tab/re-activate-user/re-activate-user";
import { sendPasswordResetEmailRequest } from "../../../utils/APICalls";
import Loading from "../../../components/loading/loading";
import ErrorNotification from "../../../components/error-notification/error-notification";
import ContactSpectrum from "../../../components/contact-spectrum/constact-spectrum";

const StatusRenderer = ({ rowData }: any) => {
  return (
    <Box sx={{ height: 52, display: "flex", alignItems: "center" }}>
      {rowData?.isActive ? (
        <Chip
          color="success"
          icon={<CheckOutlinedIcon />}
          label="Active"
          variant="outlined"
        />
      ) : (
        <Chip
          color="error"
          icon={<CloseOutlinedIcon />}
          label="Inactive"
          variant="outlined"
        />
      )}
    </Box>
  );
};

const NameRenderer = ({ rowData }: any) => {
  const navigate = useNavigate();
  const onViewDetailsClick = () => {
    navigate(`/users/${rowData?.firstName} ${rowData?.lastName}`, {
      state: rowData,
    });
  };
  return (
    <Box>
      <Button
        sx={{ textTransform: "none", px: 0, mt: -0.4 }}
        onClick={onViewDetailsClick}
      >
        <Typography fontSize={14}>
          {rowData?.firstName} {rowData?.lastName}
        </Typography>
      </Button>
    </Box>
  );
};

const ClientRenderer = ({ value }: any) => {
  // const navigate = useNavigate();
  // const selectedRow = rowData?.filter((data: any) => data.id === id)[0];
  // const onViewDetailsClick = () => {
  //     navigate(`/users/${selectedRow?.displayName}`, { state: selectedRow });
  // }
  return (
    <Box>
      <Button sx={{ textTransform: "none", px: 0 }}>
        {value ? (
          <Typography>{value}</Typography>
        ) : (
          <Typography sx={{ color: "rgba(0, 0, 0, 0.87)" }}>N/A</Typography>
        )}
      </Button>
    </Box>
  );
};

const InspectionFirmRenderer = ({ value }: any) => {
  // const navigate = useNavigate();
  // const selectedRow = rowData?.filter((data: any) => data.id === id)[0];
  // const onViewDetailsClick = () => {
  //     navigate(`/users/${selectedRow?.displayName}`, { state: selectedRow });
  // }
  return (
    <Box>
      <Button sx={{ textTransform: "none", px: 0 }}>
        {value ? (
          <Typography>{value}</Typography>
        ) : (
          <Typography sx={{ color: "rgba(0, 0, 0, 0.87)" }}>N/A</Typography>
        )}
      </Button>
    </Box>
  );
};

interface HeaderProps {
  field: string;
  sortField: string;
  headerName: string | undefined;
  showFilter: boolean;
  width?: number;
  onFilterSubmit: (value: any) => void;
}

const HeaderWithTextField = ({
  field,
  sortField,
  headerName,
  showFilter,
  width,
  onFilterSubmit,
}: HeaderProps) => {
  const [text, setText] = useState("");
  const [sort, setSort] = useState("asc");
  const [debouncedInputValue, setDebouncedInputValue] = useState("");

  useEffect(() => {
    const delayInputTimeoutId = setTimeout(() => {
      setDebouncedInputValue(text);
    }, 500);
    return () => clearTimeout(delayInputTimeoutId);
  }, [text]);

  useEffect(() => {
    onFilterSubmit({ [field]: debouncedInputValue });
  }, [debouncedInputValue]); // eslint-disable-line

  const toggleSorting = () => {
    onFilterSubmit({ sortColumn: sortField, sortOrder: sort });
    setSort(sort === "asc" ? "desc" : "asc");
  };

  return (
    <Box sx={{ width, pr: 1 }}>
      <Box
        className="header"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontWeight: "bold" }}>{headerName}</Typography>
        <IconButton aria-label="sort" onClick={toggleSorting}>
          {sort === "asc" ? (
            <ArrowUpwardOutlinedIcon
              className="ArrowUpwardIcon"
              sx={{ fontSize: 17, display: "none" }}
            />
          ) : (
            <ArrowDownwardOutlinedIcon
              className="ArrowUpwardIcon"
              sx={{ fontSize: 17, display: "none" }}
            />
          )}
        </IconButton>
      </Box>
      <TextField
        variant="outlined"
        placeholder={headerName}
        fullWidth
        size="small"
        sx={{
          mt: 1,
          display: showFilter ? "block" : "none",
        }}
        className="filterTextField"
        value={text}
        onChange={(e) => setText(e.target.value)}
      />
    </Box>
  );
};

interface HeaderWithSelectProps {
  field: string;
  sortField: string;
  headerName: string | undefined;
  showFilter: boolean;
  width?: number;
  values?: string[];
  onFilterSubmit: (value: any) => void;
}

const HeaderWithSelect = ({
  field,
  sortField,
  headerName,
  showFilter,
  width,
  values,
  onFilterSubmit,
}: HeaderWithSelectProps) => {
  const dropdownWidth = width && width - 20;
  const [sort, setSort] = useState("asc");
  const [selectedValue, setSelectedValue] = useState("");

  const toggleSorting = () => {
    onFilterSubmit({ sortColumn: sortField, sortOrder: sort });
    setSort(sort === "asc" ? "desc" : "asc");
  };
  const onSelectChange = (event: any) => {
    setSelectedValue(event.target.value);
    if (field === "isActive") {
      statusFilter(event.target.value);
    } else if (field === "userType") {
      userTypeFilter(event.target.value);
    }
  };

  const statusFilter = (value: string) => {
    value === "Active"
      ? onFilterSubmit({ isActive: true })
      : onFilterSubmit({ isActive: false });
  };

  const userTypeFilter = (value: string) => {
    if (value === "Client User") {
      onFilterSubmit({ userType: 1 });
    } else if (value === "Inspector User") {
      onFilterSubmit({ userType: 2 });
    } else if (value === "Internal User") {
      onFilterSubmit({ userType: 0 });
    }
  };

  return (
    <Box sx={{ width, pr: 1 }}>
      <Box
        className="header"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontWeight: "bold" }}>{headerName}</Typography>
        <IconButton aria-label="sort" onClick={toggleSorting}>
          {sort === "asc" ? (
            <ArrowUpwardOutlinedIcon
              className="ArrowUpwardIcon"
              sx={{ fontSize: 17, display: "none" }}
            />
          ) : (
            <ArrowDownwardOutlinedIcon
              className="ArrowUpwardIcon"
              sx={{ fontSize: 17, display: "none" }}
            />
          )}
        </IconButton>
      </Box>
      <FormControl sx={{ display: showFilter ? "block" : "none", mt: 1 }}>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          size="small"
          sx={{
            width: dropdownWidth,
            "& .MuiSelect-select span::before": {
              content: "'Select'",
              color: "rgba(0, 0, 0, 0.42)",
            },
          }}
          value={selectedValue}
          onChange={onSelectChange}
        >
          {values?.map((type) => (
            <MenuItem key={type} value={type}>
              {type}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

const HeaderWithDatePicker = ({
  field,
  sortField,
  headerName,
  showFilter,
  width,
  onFilterSubmit,
}: HeaderProps) => {
  const [value, setValue] = useState<Dayjs | null>(null);
  const [sort, setSort] = useState("asc");

  const toggleSorting = () => {
    onFilterSubmit({ sortColumn: sortField, sortOrder: sort });
    setSort(sort === "asc" ? "desc" : "asc");
  };

  const onDateChange = (date: Dayjs | null) => {
    setValue(date);
    const formattedDate = dayjs(date).format("YYYY-MM-DD");
    if (dayjs(formattedDate).isValid())
      onFilterSubmit({ [field]: formattedDate });
    else onFilterSubmit({ [field]: "" });
  };

  return (
    <Box sx={{ width, pr: 1 }}>
      <Box
        className="header"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontWeight: "bold" }}>{headerName}</Typography>
        <IconButton aria-label="sort" onClick={toggleSorting}>
          {sort === "asc" ? (
            <ArrowUpwardOutlinedIcon
              className="ArrowUpwardIcon"
              sx={{ fontSize: 17, display: "none" }}
            />
          ) : (
            <ArrowDownwardOutlinedIcon
              className="ArrowUpwardIcon"
              sx={{ fontSize: 17, display: "none" }}
            />
          )}
        </IconButton>
      </Box>
      <Box
        sx={{
          width: "auto",
          height: "auto",
          display: showFilter ? "block" : "none",
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            sx={{
              width: 170,
              height: 40,
              mt: 1,
              "& .MuiInputBase-root": {
                "& .MuiInputBase-input": {
                  padding: 1,
                },
              },
            }}
            value={value}
            onChange={(date) => onDateChange(date)}
          />
        </LocalizationProvider>
      </Box>
    </Box>
  );
};

export default function Users() {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [userType, setUserType] = useState("allUsers");
  const [openDialog, setOpenDialog] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [addedUser, setAddedUser] = useState<any>();
  const [rowSelectionModel, setRowSelectionModel] =
    useState<GridRowSelectionModel>([]);
  const [openAddClientDialog, setOpenAddClientDialog] = useState(false);
  const [openAddInternalUserDialog, setOpenAddInternalUserDialog] =
    useState(false);
  const [rowData, setRowData] = useState<any>([]);
  const [showTableFilter, setShowTableFilter] = useState(true);
  const [headerHeight, setHeaderHeight] = useState(104);
  const [filterParams, setFilterParams] = useState({});
  const [paginationModel, setPaginationModel] = useState<any>();
  const [showDeactivateDialog, setShowDeactivateDialog] = useState(false);
  const [showReactivateDialog, setShowReactivateDialog] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [showErrorNotification, setShowErrorNotification] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [sendingPasswordReset, setSendingPasswordReset] = useState(false);
  const [filterResetKey, setFilterResetKey] = useState(0);

  const { currentUser } = useSelector((state: any) => state.user.user);
  const { loading } = useSelector((state: any) => state.user);
  const { allUsers } = useSelector((state: any) => state.user.user);

  const dispatch = useDispatch();

  const rowCountRef = useRef(allUsers?.totalCount || 0);
  const rowCount = useMemo(() => {
    if (allUsers?.totalCount !== undefined) {
      rowCountRef.current = allUsers?.totalCount;
    }
    return rowCountRef.current;
  }, [allUsers?.totalCount]);

  const column: GridColDef[] =
    currentUser?.userType === currentUserType.tenant
      ? [
          {
            field: "name",
            headerName: "Name",
            width: 140,
            sortable: false,
            renderCell: (params: GridRenderCellParams<any>) => (
              <NameRenderer rowData={params?.row} />
            ),
            renderHeader: (params) => (
              <HeaderWithTextField
                field={params.colDef.field}
                sortField="name"
                headerName={params.colDef.headerName}
                showFilter={showTableFilter}
                onFilterSubmit={onFilterUsers}
              />
            ),
          },
          {
            field: "username",
            headerName: "Username",
            width: 150,
            sortable: false,
            renderHeader: (params) => (
              <HeaderWithTextField
                field={params.colDef.field}
                sortField="username"
                headerName={params.colDef.headerName}
                width={params.colDef.width}
                showFilter={showTableFilter}
                onFilterSubmit={onFilterUsers}
              />
            ),
          },
          {
            field: "primaryEmail",
            headerName: "Primary Email",
            width: 180,
            sortable: false,
            renderHeader: (params) => (
              <HeaderWithTextField
                field={params.colDef.field}
                sortField="email"
                headerName={params.colDef.headerName}
                width={params.colDef.width}
                showFilter={showTableFilter}
                onFilterSubmit={onFilterUsers}
              />
            ),
          },
          {
            field: "primaryPhone",
            headerName: "Primary Phone",
            width: 180,
            sortable: false,
            renderHeader: (params) => (
              <HeaderWithTextField
                field={params.colDef.field}
                sortField="phone"
                headerName={params.colDef.headerName}
                width={params.colDef.width}
                showFilter={showTableFilter}
                onFilterSubmit={onFilterUsers}
              />
            ),
          },
          {
            field: "status",
            headerName: "Status",
            width: 130,
            sortable: false,
            renderCell: (params: GridRenderCellParams<any>) => (
              <StatusRenderer rowData={params?.row} />
            ),
            renderHeader: (params) => (
              <HeaderWithSelect
                field="isActive"
                sortField="status"
                headerName={params.colDef.headerName}
                width={params.colDef.width}
                showFilter={showTableFilter}
                values={["Active", "Inactive"]}
                onFilterSubmit={onFilterUsers}
              />
            ),
          },
          {
            field: "userType",
            headerName: "User Type",
            width: 160,
            sortable: false,
            renderHeader: (params) => (
              <HeaderWithSelect
                field={params.colDef.field}
                sortField="usertype"
                headerName={params.colDef.headerName}
                width={params.colDef.width}
                showFilter={showTableFilter}
                values={["Client User", "Inspector User", "Internal User"]}
                onFilterSubmit={onFilterUsers}
              />
            ),
          },
          {
            field: "clientName",
            headerName: "Client",
            width: 180,
            sortable: false,
            renderCell: (params: GridRenderCellParams<any>) => (
              <ClientRenderer value={params?.value} />
            ),
            renderHeader: (params) => (
              <HeaderWithTextField
                field={params.colDef.field}
                sortField="client"
                headerName={params.colDef.headerName}
                showFilter={showTableFilter}
                onFilterSubmit={onFilterUsers}
              />
            ),
          },
          {
            field: "inspectorFirmName",
            headerName: "Inspection Firm",
            width: 180,
            sortable: false,
            renderCell: (params: GridRenderCellParams<any>) => (
              <InspectionFirmRenderer value={params?.value} />
            ),
            renderHeader: (params) => (
              <HeaderWithTextField
                field={params.colDef.field}
                sortField="inspectorfirm"
                headerName={params.colDef.headerName}
                width={params.colDef.width}
                showFilter={showTableFilter}
                onFilterSubmit={onFilterUsers}
              />
            ),
          },
          {
            field: "roleNames",
            headerName: "Role(s)",
            width: 180,
            sortable: false,
            renderHeader: (params) => (
              <HeaderWithTextField
                field="roleName"
                sortField="role"
                headerName={params.colDef.headerName}
                width={params.colDef.width}
                showFilter={showTableFilter}
                onFilterSubmit={onFilterUsers}
              />
            ),
          },
          {
            field: "lastLoginDateTime",
            headerName: "Last Login",
            width: 200,
            sortable: false,
            valueFormatter: (value?: string) =>
              value ? dayjs(value).format("MM/DD/YYYY") : " ",
            renderHeader: (params) => (
              <HeaderWithDatePicker
                field="lastLogin"
                sortField="lastlogin"
                headerName={params.colDef.headerName}
                showFilter={showTableFilter}
                onFilterSubmit={onFilterUsers}
              />
            ),
          },
        ]
      : [
          {
            field: "name",
            headerName: "Name",
            width: 140,
            sortable: false,
            renderCell: (params: GridRenderCellParams<any>) => (
              <NameRenderer rowData={params?.row} />
            ),
            renderHeader: (params) => (
              <HeaderWithTextField
                field={params.colDef.field}
                sortField="name"
                headerName={params.colDef.headerName}
                showFilter={showTableFilter}
                onFilterSubmit={onFilterUsers}
              />
            ),
          },
          {
            field: "username",
            headerName: "Username",
            width: 180,
            sortable: false,
            renderHeader: (params) => (
              <HeaderWithTextField
                field={params.colDef.field}
                sortField="username"
                headerName={params.colDef.headerName}
                width={params.colDef.width}
                showFilter={showTableFilter}
                onFilterSubmit={onFilterUsers}
              />
            ),
          },
          {
            field: "primaryEmail",
            headerName: "Primary Email",
            width: 200,
            sortable: false,
            renderHeader: (params) => (
              <HeaderWithTextField
                field={params.colDef.field}
                sortField="email"
                headerName={params.colDef.headerName}
                width={params.colDef.width}
                showFilter={showTableFilter}
                onFilterSubmit={onFilterUsers}
              />
            ),
          },
          {
            field: "primaryPhone",
            headerName: "Primary Phone",
            width: 180,
            sortable: false,
            renderHeader: (params) => (
              <HeaderWithTextField
                field={params.colDef.field}
                sortField="phone"
                headerName={params.colDef.headerName}
                width={params.colDef.width}
                showFilter={showTableFilter}
                onFilterSubmit={onFilterUsers}
              />
            ),
          },
          {
            field: "status",
            headerName: "Status",
            width: 130,
            sortable: false,
            renderCell: (params: GridRenderCellParams<any>) => (
              <StatusRenderer rowData={params?.row} />
            ),
            renderHeader: (params) => (
              <HeaderWithSelect
                field="isActive"
                sortField="status"
                headerName={params.colDef.headerName}
                width={params.colDef.width}
                showFilter={showTableFilter}
                values={["Active", "Inactive"]}
                onFilterSubmit={onFilterUsers}
              />
            ),
          },
          {
            field: "roleNames",
            headerName: "Role(s)",
            width: 220,
            sortable: false,
            renderHeader: (params) => (
              <HeaderWithTextField
                field="roleName"
                sortField="role"
                headerName={params.colDef.headerName}
                width={params.colDef.width}
                showFilter={showTableFilter}
                onFilterSubmit={onFilterUsers}
              />
            ),
          },
          {
            field: "lastLoginDateTime",
            headerName: "Last Login",
            width: 200,
            sortable: false,
            valueFormatter: (value?: string) =>
              value ? dayjs(value).format("MM/DD/YYYY") : " ",
            renderHeader: (params) => (
              <HeaderWithDatePicker
                field="lastLogin"
                sortField="lastlogin"
                headerName={params.colDef.headerName}
                showFilter={showTableFilter}
                onFilterSubmit={onFilterUsers}
              />
            ),
          },
        ];

  useEffect(() => {
    setPaginationModel({
      page: 0,
      pageSize: 10,
    });
  }, []);

  useEffect(() => {
    setRowData(allUsers?.items);
  }, [allUsers]);

  useEffect(() => {
    if (paginationModel) {
      const pagination = { ...paginationModel };
      pagination.page = paginationModel?.page + 1;
      setFilterParams({ ...filterParams, ...pagination });
    }
  }, [paginationModel]); // eslint-disable-line

  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onMenuItemClick = (createUserType: string) => {
    setAnchorEl(null);
    if (createUserType === addUserRole.client) {
      setOpenAddClientDialog(true);
    } else if (createUserType === addUserRole.inspector) {
      setOpenDialog(true);
    } else if (createUserType === addUserRole.internalUser) {
      setOpenAddInternalUserDialog(true);
    }
  };

  const onAddUserClick = () => {
    if (currentUser?.userType === currentUserType.client) {
      setOpenAddClientDialog(true);
    } else if (currentUser?.userType === currentUserType.inspector) {
      setOpenDialog(true);
    }
  };

  const handleChange = (event: SelectChangeEvent) => {
    const type = event.target.value;
    setUserType(type);

    if (type === "client") {
      onFilterUsers({ userType: 1 });
    } else if (type === "inspector") {
      onFilterUsers({ userType: 2 });
    } else if (type === "internal") {
      onFilterUsers({ userType: 0 });
    } else if (type === "allUsers") {
      onFilterUsers({ userType: "" });
    }
  };

  const addUser = (user: any) => {
    setAddedUser(user);
    setShowAlert(true);
    setPaginationModel({
      page: 0,
      pageSize: 10,
    });
  };

  const handleDeactivateOrActivateUser = () => {
    if (rowSelectionModel.length !== 1) return;

    if (isSelectedUserActive()) {
      setShowDeactivateDialog(true);
    } else {
      setShowReactivateDialog(true);
    }
  };

  const onCloseDeactivateDialog = () => {
    setShowDeactivateDialog(false);
  };

  const onCloseReactivateDialog = () => {
    setShowReactivateDialog(false);
  };

  const onDeactivateSuccess = () => {
    setNotificationMessage("User has been deactivated successfully.");
    setShowNotification(true);
    setRowSelectionModel([]);
    if (Object.keys(filterParams).length > 0) {
      dispatch(getAllUserRequest(filterParams));
    }
  };

  const onReactivateSuccess = () => {
    setNotificationMessage("User has been activated successfully.");
    setShowNotification(true);
    setRowSelectionModel([]);
    if (Object.keys(filterParams).length > 0) {
      dispatch(getAllUserRequest(filterParams));
    }
  };

  const onDeactivateError = (message: string) => {
    setErrorMessage(message);
    setShowErrorNotification(true);
  };

  const onReactivateError = (message: string) => {
    setErrorMessage(message);
    setShowErrorNotification(true);
  };

  const isSelectedUserActive = () => {
    if (rowSelectionModel.length !== 1) return false;
    const selectedUserId = rowSelectionModel[0];
    const selectedUser = rowData?.find(
      (user: any) => user.id === selectedUserId
    );
    return selectedUser?.isActive === true;
  };

  const handleSendPasswordResetEmail = async () => {
    if (rowSelectionModel.length !== 1) return;

    setSendingPasswordReset(true);
    try {
      const response = await sendPasswordResetEmailRequest(
        rowSelectionModel[0] as string
      );

      if (response?.status === 200 || response?.status === 204) {
        setNotificationMessage("Password reset email sent successfully.");
        setShowNotification(true);
        setRowSelectionModel([]);
      } else {
        setErrorMessage(
          response?.data?.message ||
            "Failed to send password reset email. Please try again."
        );
        setShowErrorNotification(true);
      }
    } catch (error) {
      setErrorMessage("Failed to send password reset email. Please try again.");
      setShowErrorNotification(true);
    } finally {
      setSendingPasswordReset(false);
    }
  };

  const onFilterClick = (value: boolean) => {
    setShowTableFilter(value);
    setHeaderHeight(value ? 104 : 56);
  };

  const onFilterUsers = (data: any) => {
    const keys = Object.keys(data);
    if (keys.includes("sortColumn")) {
      setFilterParams({ ...filterParams, ...data });
    } else {
      keys.forEach((key: string) => {
        if (filterParams.hasOwnProperty(key) && data[key] === "") {
          const { [key]: removedKey, ...filters } = filterParams as any;
          setFilterParams(filters);
        } else if (data[key] || data[key] === 0 || data[key] === false) {
          //if isActive status is false and if userType is 0 then condition also should pass
          setFilterParams({ ...filterParams, [key]: data[key] });
        }
      });
    }
  };

  const onClearAllFilters = () => {
    setUserType("allUsers");
    setPaginationModel({
      page: 0,
      pageSize: 10,
    });
    setFilterParams({
      page: 1,
      pageSize: 10,
    } as any);
    setFilterResetKey((prev) => prev + 1);
  };

  useEffect(() => {
    //Removing filterParams object key if their value is empty
    const filters = filterParams as any;
    Object.keys(filterParams)?.forEach((key: string) => {
      if (filters.hasOwnProperty(key) && filters[key] === "") {
        delete filters[key];
      }
    });
    if (Object.keys(filters).length > 0) {
      dispatch(getAllUserRequest(filters));
    }
  }, [filterParams]); // eslint-disable-line

  return (
    <>
      <ContactSpectrum />
      <Breadcrumb />
      <Typography sx={{ fontSize: 34, ml: 2 }}>All Users</Typography>
      <Box
        sx={{
          mt: 3,
          px: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {currentUser?.userType === currentUserType.tenant ? (
          <FormControl sx={{ minWidth: 250, height: 40 }}>
            <InputLabel id="demo-simple-select-label">Display</InputLabel>
            <Select
              sx={{ height: 40 }}
              labelId="demo-select-small-label"
              id="demo-select-small"
              value={userType}
              label="Display"
              onChange={handleChange}
            >
              <MenuItem value="allUsers">All Users</MenuItem>
              <MenuItem value="internal">Internal Users</MenuItem>
              <MenuItem value="client">Client Users</MenuItem>
              <MenuItem value="inspector">Inspection Users</MenuItem>
            </Select>
          </FormControl>
        ) : (
          <Box></Box>
        )}
        {currentUser?.userType === currentUserType.tenant ? (
          <Box>
            <Button
              className="primary-bg"
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              variant="contained"
              disableElevation
              onClick={handleClick}
              startIcon={<AddIcon />}
              endIcon={<KeyboardArrowDownIcon />}
            >
              Add User
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem
                onClick={() => onMenuItemClick(addUserRole.internalUser)}
              >
                Internal User
              </MenuItem>
              <MenuItem onClick={() => onMenuItemClick(addUserRole.client)}>
                Client User
              </MenuItem>
              <MenuItem onClick={() => onMenuItemClick(addUserRole.inspector)}>
                Inspection User
              </MenuItem>
            </Menu>
          </Box>
        ) : (
          <Button
            className="primary-bg"
            id="basic-button"
            variant="contained"
            disableElevation
            onClick={onAddUserClick}
            startIcon={<AddIcon />}
          >
            Add User
          </Button>
        )}
      </Box>

      <Box className="clients-header" sx={{ my: 2 }}>
        <Box display={"flex"} alignItems={"center"}>
          <Button
            variant="text"
            onClick={handleSendPasswordResetEmail}
            disabled={rowSelectionModel.length !== 1}
          >
            Send Password Reset Email
          </Button>
          <Button
            variant="text"
            onClick={handleDeactivateOrActivateUser}
            disabled={rowSelectionModel.length !== 1}
          >
            {rowSelectionModel.length === 1 && !isSelectedUserActive()
              ? "Activate User"
              : "Deactivate User"}
          </Button>
          <Divider orientation="vertical" sx={{ mx: 0.5, height: 34 }} />
          <IconButton
            aria-label="delete"
            disabled //{rowSelectionModel.length === 0}
          >
            <DeleteOutlinedIcon
              color="disabled" //{rowSelectionModel.length === 0 ? "disabled" : "primary"}
            />
          </IconButton>
        </Box>
        <Box display={"flex"}>
          <IconButton aria-label="clear-all" onClick={onClearAllFilters}>
            <ClearAllOutlined color="primary" />
          </IconButton>
          <IconButton
            aria-label="filter"
            onClick={() => onFilterClick(!showTableFilter)}
          >
            {showTableFilter ? (
              <FilterAltOffOutlinedIcon color="primary" />
            ) : (
              <FilterAltOutlinedIcon color="primary" />
            )}
          </IconButton>
        </Box>
      </Box>

      <Box sx={{ mx: 2 }}>
        <Table
          key={filterResetKey}
          rowData={rowData}
          rowCount={rowCount}
          loading={loading}
          columnDef={column}
          headerHeight={headerHeight}
          onRowSelectionModelChange={(newRowSelectionModel: any) => {
            setRowSelectionModel(newRowSelectionModel);
          }}
          rowSelectionModel={rowSelectionModel}
          disableColumnMenu={true}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
        />
      </Box>

      <CreateInspectorUser
        showDialog={openDialog}
        closeDialog={() => setOpenDialog(false)}
        addUser={addUser}
      />

      <CreateClientUser
        showDialog={openAddClientDialog}
        closeDialog={() => setOpenAddClientDialog(false)}
        addUser={addUser}
      />

      {openAddInternalUserDialog && (
        <CreateInternalUser
          showDialog={openAddInternalUserDialog}
          closeDialog={() => setOpenAddInternalUserDialog(false)}
          addUser={addUser}
        />
      )}

      <Notification
        show={showAlert}
        message={`${addedUser?.username} has been added to Spectrum.`}
        onClose={() => setShowAlert(false)}
      />

      <Notification
        show={showNotification}
        message={notificationMessage}
        onClose={() => setShowNotification(false)}
      />

      <ErrorNotification
        show={showErrorNotification}
        message={errorMessage}
        onClose={() => setShowErrorNotification(false)}
      />

      {showDeactivateDialog && (
        <DeactivateUserDialog
          showDialog={showDeactivateDialog}
          closeDialog={onCloseDeactivateDialog}
          id={rowSelectionModel[0] as string}
          onSuccess={onDeactivateSuccess}
          onError={onDeactivateError}
        />
      )}

      {showReactivateDialog && (
        <ReActivateUserDialog
          showDialog={showReactivateDialog}
          closeDialog={onCloseReactivateDialog}
          id={rowSelectionModel[0] as string}
          onSuccess={onReactivateSuccess}
          onError={onReactivateError}
        />
      )}

      {sendingPasswordReset && <Loading />}
    </>
  );
}
